<template>
  <div class="candidate-bio">
    <div class="candidate-bio-header">
      <div class="candidate-bio-image">
        <Avatar :picture="extraBio.picture" size="150px" />
      </div>
      <p class="candidate-bio-name">{{ extraBio.firstname }}</p>
    </div>
    <div v-if="extraBio?.candidate_reports.total_reports > 0" class="text-center q-my-md">
      <QChip class="q-pr-none bg-grey-2">
        <QAvatar icon="fa fa-triangle-exclamation" color="red" text-color="white" />
        {{ $tc("ETAB.PAGES.CANDIDATE.CARD.@REPORTS", extraBio.candidate_reports.total_reports) }}
        <QBtn color="grey" round flat dense :icon="expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'" @click="expanded = !expanded" />
      </QChip>

      <QSlideTransition>
        <div v-show="expanded">
          <QList class="bg-grey-2 rounded-borders q-mx-sm" separator>
            <QItem v-for="report in extraBio.candidate_reports.reports" v-show="report.nb_report > 0" :key="report" class="text-left">
              <QItemSection>
                <QItemLabel class="text-caption">
                  <QIcon :name="CANDIDATE_REPORTS[report.name].icon" color="red" size="18px" class="q-mr-sm q-mb-xs align-bottom" />
                  {{ $t(CANDIDATE_REPORTS[report.name].text) }}
                </QItemLabel>
              </QItemSection>

              <QItemSection side>
                <QBadge color="red">
                  {{ report.nb_report }}
                </QBadge>
              </QItemSection>
            </QItem>
          </QList>
        </div>
      </QSlideTransition>
    </div>
    <div class="candidate-bio-description">
      <p>{{ extraBio.bio }}</p>
    </div>
    <div class="candidate-bio-details">
      <div class="candidate-bio-detail-item">
        <QIcon name="fad fa-location-dot" color="secondary" size="21px" />
        <span>{{ extraBio.postal_code }}</span>
      </div>
      <QSeparator vertical />
      <div class="candidate-bio-detail-item">
        <QIcon name="fad fa-cake-candles" color="secondary" size="21px" />
        <span>{{ $t("ETAB.PAGES.EXTRA.@AGE", { age }) }}</span>
      </div>
      <QSeparator v-if="extraBio.is_driving" vertical />
      <div v-if="extraBio.is_driving" class="candidate-bio-detail-item">
        <QIcon name="fad fa-car" color="secondary" size="21px" />
        <span>{{ $t("ETAB.PAGES.EXTRA.@IS_MOTORIZED") }}</span>
      </div>
    </div>
    <QSeparator v-if="extraBio.phone || extraBio.email" class="q-mt-md" />
    <div v-if="extraBio.phone || extraBio.email" class="q-mt-md flex column flew-wrap">
      <div v-if="extraBio.phone" class="candidate-bio-detail-item">
        <QIcon name="fad fa-phone" color="secondary" size="21px" />
        <span>{{ extraBio.phone }}</span>
      </div>
      <div v-if="extraBio.email" class="candidate-bio-detail-item q-mt-sm">
        <QIcon name="fad fa-envelope" color="secondary" size="21px" />
        <span>{{ email }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { defineProps, computed, ref } from "vue";
  import { DatesHelpers } from "@core/helpers";
  import { CANDIDATE_REPORTS, limitText } from "@extracadabra/core-v2";
  import { Screen } from "quasar";

  const props = defineProps({
    extraBio: {
      type: Object,
      default: () => {},
    },
  });
  const expanded = ref(false);
  const age = computed(() => DatesHelpers.getAge(props.extraBio.birthdate));
  const limitByDevice = computed(() => (Screen.lt.sm ? 30 : 100));
  const email = computed(() => limitText({ str: props.extraBio.email, limit: limitByDevice.value }));
</script>

<style lang="scss" scoped>
  .candidate-bio {
    position: relative;
    background: white;
    border-radius: 16px;
    margin-top: 100px;
    padding: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    &-header {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 16px;
      padding-top: 65px;
    }
    &-image {
      position: absolute;
      margin-bottom: 12px;
      top: -90px;
    }
    .rounded-image {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }
    &-name {
      color: $primary;
      font-size: 24px;
      font-weight: 800;
      margin: 0;
    }
    &-description {
      text-align: center;
      margin-bottom: 20px;
      font-size: 16px;
      font-weight: 500;
    }
    &-details {
      display: flex;
      justify-content: space-around;
      padding-top: 16px;
      border-top: 1px solid #eee;
    }
    &-detail-item {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #666;
    }
  }
</style>
